import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "./redux/actions";
import Fileupload from "../fileupload/Fileupload";
import MaterialTable from "material-table";
import AskAlert from "../common/AskAlert";
import {
  SERVER_PATH,
  AXIOS_CONFIG,
  ROLE_ADMIN,
} from "../common/redux/constantes";

class ListPhases extends Component {
  static propTypes = {
    phase: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state ={
    phases:[],
    openDeleteAlert:false,
    deletePhaseID:-1,
    openUploadFileModal:false
  }

  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
  }

  deletePhase = () => {
    if (this.state.deletePhaseID !== -1) {
      this.props.actions.deletePhase(this.tableRef, this.state.deletePhaseID);
      this.setState({ openDeleteAlert: false });
    }
  };

  cancelDelete = () => {
    this.setState({ openDeleteAlert: false });
  };

  askDeletePhase = (phaseID) => {
    this.setState({ openDeleteAlert: true, deletePhaseID: phaseID });
  };

  refreshTable = () => {
    this.tableRef.current && this.tableRef.current.onQueryChange();
  };

  uploadCsv=()=>{
    this.setState({
      openUploadFileModal:true
    })
  }
  closeCsvModal=()=>{
    this.setState({
      openUploadFileModal:false
    })
  }
  updateAfterCsv=()=>{
    this.tableRef.current && this.tableRef.current.onQueryChange()
  }
  render() {

      let actionButtons =[
        rowData => ({
          icon: 'delete',
          tooltip: 'Delete',
          onClick: (event, rowData) => this.askDeletePhase(rowData.phase),
          disabled: rowData.shared===1 
        }),
        rowData => ({
          icon: 'edit',
          tooltip: 'Edit',
          onClick: (event, rowData) => this.props.editPhase(rowData),
          disabled: rowData.shared===1
        }),
        {
          icon: 'cloud_upload',
          tooltip: 'Import',
          isFreeAction: true,
          onClick: () => this.uploadCsv()
          },
        {
          icon: 'visibility',
          tooltip: 'View information',
          onClick: (event, rowData) => this.props.showPhase(rowData) 
        },
        {
        icon: 'refresh',
        tooltip: 'Refresh Data',
        isFreeAction: true,
        onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange()
        }
      ];
      //Verificamos permisos
      if(Number(localStorage.getItem("role"))!==ROLE_ADMIN)
      {
        actionButtons.splice(0,3);
      }
      return (
        <div >
          <MaterialTable
          tableRef={this.tableRef}
          onRowClick={(evt, selectedRow) => this.setState({ selectedRow })}
          options={{
            actionsColumnIndex: 7,
            paging: false,
            search: false,
            maxBodyHeight: "600px",
            headerStyle: {
              backgroundColor: "#fffff",
              color: "black",
              fontSize: "1.05em",
            },
            rowStyle: (rowData) => {
              return {
                backgroundColor:
                  this.state.selectedRow &&
                  this.state.selectedRow.tableData.id === rowData.tableData.id
                    ? "#EEE"
                    : rowData.tableData.id % 2
                    ? "#fff"
                    : "#f9f9fa",
              };
            },
          }}
          title="Phases"
          columns={[
            {
              title: "Name",
              field: "name",
              cellStyle: {
                borderRight: "1px solid #d4d4d4",
              },
            },
            {
              title: "Status",
              field: "phase_status",
              lookup: { 1: "Active", 2: "Inactive" },
              cellStyle: {
                borderRight: "1px solid #d4d4d4",
              },
            },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = SERVER_PATH + "/phases/getAll";
              fetch(url, AXIOS_CONFIG())
                .then((response) => response.json())
                .then((result) => {
                  resolve({
                    data: result.phases,
                    page: 0,
                    totalCount: result.phases.length,
                  });
                })
                .catch((err) => {
                  resolve({ data: [], page: 0, totalCount: 0 });
                });
            })
          }
          actions={actionButtons}
        />
         <Fileupload 
          openDialog={this.state.openUploadFileModal} 
          closeDialog={this.closeCsvModal}
          updateAfterCsv={this.updateAfterCsv}
          type={4}
        />
        <AskAlert
          openAlert={this.state.openDeleteAlert}
          handleCloseCancel={this.cancelDelete}
          handleCloseOk={this.deletePhase}
          dialogTitle="Delete Phase"
          dialogContent="Are you sure to delete this phase?"
        />
        </div>
      )
    }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    phase: state.phase,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { withRef: true }
)(ListPhases);



// WEBPACK FOOTER //
// ./src/features/phase/ListPhases.js